import { render, staticRenderFns } from "./SvgThumbsUp.vue?vue&type=template&id=2e4a6002"
import script from "./SvgThumbsUp.vue?vue&type=script&lang=js"
export * from "./SvgThumbsUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports